import React, {
    useEffect,
    useCallback,
    useContext,
    useState,
    useRef,
  } from "react";
  import EntriesDataContext from "../../../context/EntriesDataContext";
  import Paper from "@mui/material/Paper";
  import Table from "@mui/material/Table";
  import TableBody from "@mui/material/TableBody";
  import TableCell from "@mui/material/TableCell";
  import TableContainer from "@mui/material/TableContainer";
  import TableHead from "@mui/material/TableHead";
  import TableRow from "@mui/material/TableRow";
  
  import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
  import { getSuccessToast, getErrorToast } from "../../../toast";
  
  import "./RecentEntriesTable.css";
  import download from "../../../assets/download.svg";
  import edit from "../../../assets/edit.svg";
  import Cancel from "../../../assets/cancel.svg";
  import submit from "../../../assets/submit.svg";
  var fileDownload = require("js-file-download");
  
  const RecentEntriesTable = () => {
    const axiosPrivate = useAxiosPrivate();
    const { resData, setResData, redirectId, setRedirectId } =
      useContext(EntriesDataContext);
    const [rowData, setRowData] = useState([]);
    // const [searched, setSearched] = useState("");
    const [editState, setEditState] = useState(false);
    const [boxId, setBoxId] = useState();
  
    const [poNo, setPoNo] = useState();
    const [partyName, setPartyName] = useState();
    const [partyList, setPartyList] = useState([]);
    const [partyCode, setPartyCode] = useState();
    const [city, setCity] = useState();
    const [checked, setChecked] = useState(false);
    const [lrNo, setLrNo] = useState();
    const [lrDate, setLrDate] = useState();
    const [caseNo, setCaseNo] = useState();
    const [goodsType, setGoodsType] = useState();
    const [receivedDate, setReceivedDate] = useState();
    const [openDate, setOpenDate] = useState();
    const [refNo, setRefNo] = useState();
    const [refDate, setRefDate] = useState();
    const [transporterName, setTransporterName] = useState();
    const [srNo, setSrNo] = useState();
    const partyNameRef = useRef("");
  
    const columns = [
      {
        id: "sr_no",
        width: "15vw",
        label: "Sr No",
      },
      {
        id: "po_no",
        width: "15vw",
        label: "PO No",
      },
      {
        id: "party_name",
        width: "15vw",
        label: "Party Name",
      },
      {
        id: "party_code",
        width: "15vw",
        label: "Party Code",
      },
  
      {
        id: "city",
        width: "15vw",
        label: "City",
      },
      {
        id: "status",
        width: "",
        label: "Status",
      },
      {
        id: "lr_no",
        width: "15vw",
        label: "LR No",
      },
      {
        id: "lr_date",
        width: "15vw",
        label: "LR Date",
      },
      {
        id: "ref_no",
        width: "15vw",
        label: "Ref No",
      },
      {
        id: "ref_date",
        width: "15vw",
        label: "Ref Date",
      },
      {
        id: "case_no",
        width: "15vw",
        label: "Case No",
      },
      {
        id: "transporter_name",
        width: "15vw",
        label: "Transporter Name",
      },
      {
        id: "received_date",
        width: "15vw",
        label: "Received Date",
      },
      {
        id: "open_date",
        width: "15vw",
        label: "Open Date",
      },
      {
        id: "date",
        width: "15vw",
        label: "Date",
      },
      {
        id: "created_by",
        width: "15vw",
        label: "Created By",
      },
      {
        id: "actions",
        width: "15vw",
        label: "Actions",
      },
    ];
  
    useEffect(() => {
      setRowData(resData);
    }, []);
  
    const handleDownload = async (id) => {
      const partyINFO = await axiosPrivate.get(`/data_entry/party-info/${id}/`);
      axiosPrivate
        .get(`/report/download-report/${id}`, {
          responseType: "blob",
        })
        .then((response) => {
          let date = new Date();
          fileDownload(response.data, "file.zip");
        })
        .catch((error) => {
          if (error.response["status"] === 501) {
            getErrorToast("claim is Empty", 1000);
          }
        });
    };
  
    function formatDate(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();
      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;
      return [day, month, year].join("-");
    }
  
    const changePartyNameHandler = (e) => {
      setPartyName(e.target.value);
  
      axiosPrivate
        .get(`/data_entry/partymaster_searchbar/?search=${e.target.value}`)
        .then((res) => {
          setPartyList(res.data.results);
        });
  
      let partyName = partyNameRef.current.value
        .substring(0, partyNameRef.current.value.lastIndexOf(" "))
        .trim();
      let partyCode =
        partyNameRef.current.value
          .substring(partyNameRef.current.value.lastIndexOf(" "))
          .trim()
  
      const filteredList = partyList.filter(
        (name) => name["name"] === partyName && name["customer"] === partyCode
      )[0];
  
      if (filteredList !== undefined) {
        setPartyName(filteredList["name"]);
        setPartyCode(filteredList["customer"]);
        setCity(filteredList["city"]);
      }
    };
  
    const editHandler = (boxId) => {
      rowData.filter((row) => {
        if (row.stockists_master_id === boxId) {
          setBoxId(row.stockists_master_id);
          setEditState(true);
          setPoNo(row.po_number);
          setSrNo(row.serial_number);
  
          setPartyName(row.party_master__name);
          setPartyCode(row.party_master__customer);
          setCity(row.party_master__city);
          setChecked(row.mark_box);
          setLrNo(row.lr_number);
          setLrDate(row.lr_date);
          setCaseNo(row.case_number);
          setGoodsType(row.goods_type);
          setReceivedDate(row.received_date);
          setOpenDate(row.open_date);
          setRefNo(row.ref_number);
          setRefDate(row.ref_date);
          setTransporterName(row.transporter_name);
        }
      });
    };
  
    const updateBoxHandler = (boxId) => {
      const data = {
        po_number: poNo,
        party_master__party_name: partyName,
        party_master__party_code: partyCode,
        party_master__city: city,
        mark_box: checked,
        lr_number: lrNo,
        lr_date: lrDate,
        case_number: caseNo,
        goods_type: goodsType,
        received_date: receivedDate,
        open_date: openDate,
        ref_number: refNo,
        ref_date: refDate,
        transporter_name: transporterName,
      };
  
      axiosPrivate
        .patch(`/dashboard/editstockistsdata/${boxId}/`, data)
        .then((res) => {
          if (res.status === 200) {
            getSuccessToast("Data updated successfully", 2000);
            setRedirectId((prev) => prev + 1);
          }
        });
  
      setEditState(false);
    };
  
    const searchBarHandler = (e) => {
      axiosPrivate
        .get(`/dashboard/search_stockistsdata/?search=${e.target.value}`)
        .then((response) => {
          setRowData(response.data.results);
        });
    };
  
    return (
      <>
        <div className="entries-header-container">
          <p className="entries-header-name">Filtered Entries</p>
          {/* <input
            placeholder="Search Details"
            className="entries-header-input"
            type="text"
            onChange={searchBarHandler}
          /> */}
        </div>
        <Paper
          style={{
            overflow: "hidden",
          }}
        >
          <TableContainer sx={{ maxHeight: "45vh" }}>
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  {columns.map((column) => (
                    <TableCell
                      style={{
                        minWidth: column.width,
                        fontSize: "0.6em",
                        padding: "0.5em",
                        textAlign: "center",
                        color: "white",
                        backgroundColor: "#000000",
                      }}
                      key={column.id}
                    >
                      {column.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {resData.map((row, idx) => (
                  <TableRow key={row.stockists_master_id}>
                    <TableCell
                      style={{
                        fontSize: "0.7em",
                        textAlign: "center",
                        padding: "0.5em",
                      }}
                    >
                      {editState && boxId === row.stockists_master_id ? (
                        <>
                          <input
                            style={{
                              width: "100%",
                            }}
                            value={srNo}
                            className="disabled"
                            disabled={true}
                          />
                        </>
                      ) : (
                        <>{idx + 1}</>
                      )}
                    </TableCell>
                    <TableCell
                      style={{
                        fontSize: "0.7em",
                        textAlign: "center",
                        padding: "0.5em",
                      }}
                    >
                      {editState && boxId === row.stockists_master_id ? (
                        <>
                          <input
                            style={{
                              width: "100%",
                            }}
                            value={poNo}
                            onChange={(e) => setPoNo(e.target.value)}
                          />
                        </>
                      ) : (
                        <>{row.po_number}</>
                      )}
                    </TableCell>
                    <TableCell
                      style={{
                        fontSize: "0.7em",
                        textAlign: "center",
                        padding: "0.5em",
                      }}
                    >
                      {editState && boxId === row.stockists_master_id ? (
                        <span>
                          <input
                            style={{
                              width: "100%",
                            }}
                            value={partyName}
                            onChange={changePartyNameHandler}
                            onFocus={changePartyNameHandler}
                            list="party-name"
                            ref={partyNameRef}
                          />
                          <datalist id="party-name">
                            {partyList.map((party) => {
                              return (
                                <option
                                  value={`${party.name} ${party.customer}`}
                                  key={party.party_master_id}
                                >
                                  {party.customer} | {party.city}
                                </option>
                              );
                            })}
                          </datalist>
                        </span>
                      ) : (
                        <>{row.party_master__name}</>
                      )}
                    </TableCell>
                    <TableCell
                      style={{
                        fontSize: "0.7em",
                        textAlign: "center",
                        padding: "0.5em",
                      }}
                    >
                      {editState && boxId === row.stockists_master_id ? (
                        <>
                          <input
                            style={{
                              width: "100%",
                            }}
                            className="disabled"
                            disabled={true}
                            value={partyCode}
                          />
                        </>
                      ) : (
                        <>{row.party_master__customer}</>
                      )}
                    </TableCell>
                    <TableCell
                      style={{
                        fontSize: "0.7em",
                        textAlign: "center",
                        padding: "0.5em",
                      }}
                    >
                      {editState && boxId === row.stockists_master_id ? (
                        <>
                          <input
                            style={{
                              width: "100%",
                            }}
                            className="disabled"
                            disabled={true}
                            value={city}
                          />
                        </>
                      ) : (
                        <>{row.party_master__city}</>
                      )}
                    </TableCell>
                    <TableCell
                      style={{
                        fontSize: "0.7em",
                        textAlign: "center",
                        padding: "0.5em",
                      }}
                    >
                      {editState && boxId === row.stockists_master_id ? (
                        <input
                          type="checkbox"
                          checked={checked}
                          onChange={() => setChecked(!checked)}
                        />
                      ) : (
                        <input
                          readOnly
                          className="box_data_input"
                          type="checkbox"
                          checked={row.mark_box}
                        />
                      )}
                    </TableCell>
                    <TableCell
                      style={{
                        fontSize: "0.7em",
                        textAlign: "center",
                        padding: "0.5em",
                      }}
                    >
                      {editState && boxId === row.stockists_master_id ? (
                        <input
                          type="text"
                          style={{
                            width: "100%",
                          }}
                          value={lrNo}
                          onChange={(e) => setLrNo(e.target.value)}
                        />
                      ) : (
                        <>{row.lr_number}</>
                      )}
                    </TableCell>
                    <TableCell
                      style={{
                        fontSize: "0.7em",
                        textAlign: "center",
                        padding: "0.5em",
                      }}
                    >
                      {editState && boxId === row.stockists_master_id ? (
                        <input
                          type="date"
                          style={{
                            width: "100%",
                          }}
                          value={lrDate}
                          onChange={(e) => setLrDate(e.target.value)}
                        />
                      ) : (
                        <>{row.lr_date}</>
                      )}
                    </TableCell>
                    <TableCell
                      style={{
                        fontSize: "0.7em",
                        textAlign: "center",
                        padding: "0.5em",
                      }}
                    >
                      {editState && boxId === row.stockists_master_id ? (
                        <input
                          type="text"
                          style={{
                            width: "100%",
                          }}
                          value={refNo}
                          onChange={(e) => setRefNo(e.target.value)}
                        />
                      ) : (
                        <>{row.ref_number}</>
                      )}
                    </TableCell>
                    <TableCell
                      style={{
                        fontSize: "0.7em",
                        textAlign: "center",
                        padding: "0.5em",
                      }}
                    >
                      {editState && boxId === row.stockists_master_id ? (
                        <input
                          type="date"
                          style={{
                            width: "100%",
                          }}
                          value={refDate}
                          onChange={(e) => setRefDate(e.target.value)}
                        />
                      ) : (
                        <>{row.ref_date}</>
                      )}
                    </TableCell>
                    <TableCell
                      style={{
                        fontSize: "0.7em",
                        textAlign: "center",
                        padding: "0.5em",
                      }}
                    >
                      {editState && boxId === row.stockists_master_id ? (
                        <input
                          style={{
                            width: "100%",
                          }}
                          type="text"
                          value={caseNo}
                          onChange={(e) => setCaseNo(e.target.value)}
                        />
                      ) : (
                        <>{row.case_number}</>
                      )}
                    </TableCell>
                    <TableCell
                      style={{
                        fontSize: "0.7em",
                        textAlign: "center",
                        padding: "0.5em",
                      }}
                    >
                      {editState && boxId === row.stockists_master_id ? (
                        <input
                          style={{
                            width: "100%",
                          }}
                          type="text"
                          value={transporterName}
                          onChange={(e) => setTransporterName(e.target.value)}
                        />
                      ) : (
                        <>{row.transporter_name}</>
                      )}
                    </TableCell>
                    <TableCell
                      style={{
                        fontSize: "0.7em",
                        textAlign: "center",
                        padding: "0.5em",
                      }}
                    >
                      {editState && boxId === row.stockists_master_id ? (
                        <input
                          style={{
                            width: "100%",
                          }}
                          type="date"
                          value={receivedDate}
                          onChange={(e) => setReceivedDate(e.target.value)}
                        />
                      ) : (
                        <>{row.received_date}</>
                      )}
                    </TableCell>
                    <TableCell
                      style={{
                        fontSize: "0.7em",
                        textAlign: "center",
                        padding: "0.5em",
                      }}
                    >
                      {editState && boxId === row.stockists_master_id ? (
                        <input
                          style={{
                            width: "100%",
                          }}
                          type="date"
                          value={openDate}
                          onChange={(e) => setOpenDate(e.target.value)}
                        />
                      ) : (
                        <>{row.open_date}</>
                      )}
                    </TableCell>
                    <TableCell
                      style={{
                        fontSize: "0.7em",
                        textAlign: "center",
                        padding: "0.5em",
                      }}
                    >
                      {formatDate(row.created_on)}
                    </TableCell>
                    <TableCell
                      style={{
                        fontSize: "0.7em",
                        textAlign: "center",
                        padding: "0.5em",
                      }}
                    >
                      {row.created_by__username}
                    </TableCell>
                    <TableCell
                      style={{
                        fontSize: "0.7em",
                        textAlign: "center",
                        padding: "0.5em",
                      }}
                    >
                      {editState && boxId === row.stockists_master_id ? (
                        <>
                          <button
                            onClick={() => {
                              updateBoxHandler(row.stockists_master_id);
                            }}
                            className="table-options-btn"
                          >
                            <img src={submit} alt="submit" />
                          </button>
                          <button
                            className="table-options-btn"
                            onClick={() => setEditState(false)}
                          >
                            <img src={Cancel} alt="cancel" />
                          </button>
                        </>
                      ) : (
                        <div>
                          <button
                            onClick={() =>
                              handleDownload(row.stockists_master_id)
                            }
                            className="table-options-btn"
                          >
                            <img src={download} alt="download" />
                          </button>
                          <button
                            onClick={() => {
                              editHandler(row.stockists_master_id);
                            }}
                            className="table-options-btn"
                          >
                            <img src={edit} alt="" />
                          </button>
                        </div>
                      )}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
      </>
    );
  };
  
  export default RecentEntriesTable;
  